import { defineComponent as _defineComponent } from 'vue'
import { useMediaAsset } from '~/composables';

interface Props {
  data?: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SoftwareCategoryAwards',
  props: {
    data: { default: () => ({}) }
  },
  setup(__props: any) {



const { getAssetUrl } = useMediaAsset();

return { __sfc: true,getAssetUrl }
}

})